var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"results-box"},[_c('h1',[_vm._v("Business Outcome")]),_c('medal',{attrs:{"medalType":_vm.label}}),_c('p',{domProps:{"innerHTML":_vm._s(_vm.desc)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }